import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import {
  ApplyRecommendationPayload,
  PhasrRecommendationsEndpoint,
  PhasrRecommendationsMethod
} from '../types';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';

export class PhasrRecommendationsGridBaseDataProvider extends BaseWebComponentDataProvider {

  public async getDataForView(): Promise<{}> {
    return {};
  }

  public async updateRecommendationBehaviourActions(payload: ApplyRecommendationPayload): Promise<{success: boolean, code?: number}> {
    return await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: PhasrRecommendationsEndpoint.RECOMMENDATION_STATE,
      method: PhasrRecommendationsMethod.UPDATE_BEHAVIOUR_ACTIONS,
      payload: payload,
    });
  }
}
